// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhh_wv bhh_iz bhh_xj bhh_i bhh_j bhh_q bhh_vr bhh_er bhh_sm bhh_sn bhh_eb","CommentsButton__icon":"il_b bhh_rx"};